const CARTO_KEY = import.meta.env.VITE_CARTO_API_KEY || ''

/** Tesela raster de CARTO. Sin `{r}`: la variante @2x responde 403 con esta clave. */
export function cartoTileUrl(stylePath) {
  const url = `https://{s}.basemaps.cartocdn.com/${stylePath}/{z}/{x}/{y}.png`
  return CARTO_KEY ? `${url}?key=${CARTO_KEY}` : url
}

export const CARTO_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
